// 资金管理
const platformRevenue = () => import('@/view/fund/platform-revenue.vue'); // 收入流水
const babyGold = () => import('@/view/fund/baby-gold.vue'); // 收入流水
export default [
  {
    path: '/platform-revenue',
    name: 'platformRevenue',
    component: platformRevenue
  },
  {
    path: '/baby-gold',
    name: 'babyGold',
    component: babyGold
  },
];